import React, { useState, useEffect } from "react";
import {
  Navigate,
  Outlet,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import Assets from "../../Layouts/Assets";
import Style from "./ProjectGallery.module.scss";
import { clearFPAUploadToken } from "../../../store/slices/Gallery/galleryFPAupload";
import { useDispatch, useSelector } from "react-redux";
import {
  clearGallery,
  currentTabHandler,
} from "../../../store/slices/Gallery/gallerySlice";
import CommonModal from "../../Modals/CommonModal";
import { useGalleryTab } from "../../../Logic/useGalleryTab";
import { updateUploadMode } from "../../../store/slices/Gallery/fileUploadSlice";
import {
  FPAGlpbalUpload,
  getFoldersByProjectID,
} from "../../../store/slices/Project/ProjectSingle";
const ProjectGallery = () => {
  /*************************************************
   * CLEARING FPA UPLOAD TOKEN TO PREVENT CO  NFLICT *
   *************************************************/
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { folderID, projectID } = useParams();
  const { allFolders } = useSelector((state) => state.projectSinglePage);
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(currentTabHandler("all"));
      dispatch(clearGallery());
      dispatch(clearFPAUploadToken());
    };
  }, []);

  // protect routing for valid folders
  useEffect(() => {
    const data = {
      page: "1",
      per_page: 20,
      sort: allFolders.filter.order,
      project_id: projectID,
    };
    dispatch(getFoldersByProjectID(data)).then((result) => {
      const folderIds = result?.payload?.data?.result?.album_list?.data?.map(
        (folder) => folder.id
      );
      if (!folderIds?.includes(Number(folderID))) {
        return navigate(`..`, { relative: "path" });
      }
    });
  }, [folderID]);

  return (
    <>
      <div className={Style.ProjectGallery}>
        <Outlet />
      </div>
    </>
  );
};

export default ProjectGallery;
